import {createContext} from "react";
import {OktaConfig} from "./api";

export const OktaEnvContext = createContext<OktaConfig>({});
